import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./Register.css";
import { useDispatch } from "react-redux";
import { register, resndOTP, verifyOTP } from "../../Redux/actions/authActions";
import {
  Google_Logo,
  ScrollX_demo,
  Scrollx_animate,
  laptopScreenV3,
} from "../../assets/icons";
import VerifyOTPModal from "./VerifyOtp";
import SignUpWithGoogle from "../GoogleSignUp/SignUpWithGoogle";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { FaAngleDown, FaAngleUp } from "react-icons/fa6";
import LoaderGlobal from "../../Components/Loader/LoaderGlobal";
import { addSurvey } from "../../Redux/actions/commonActtion";

export default function NewSignup() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [size, setSize] = useState({
    winWidth: window.innerWidth,
    winHeight: window.innerHeight,
  });

  const otpType = "signUp";
  const [otp, setOpt] = useState("");
  const [inValidOtp, setInValidOtp] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [path, setPath] = useState("");
  const [successModal, setSuccessModal] = useState(false);
  const [errorMesg, setErrorMesg] = useState("");
  const [isTermsandcon, setIsTermsandcon] = useState(false);
  const [isSignUpSuccess, setIsSignUpSuccess] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [signupLoading, setSignupLoading] = useState(false);
  const [dropDown, setDropDown] = useState(false);
  const [error, setError] = useState("");
  const [answer, setAnswer] = useState({
    value: "",
    label: "",
  });

  const data = [
    {
      id: "search",
      value: "googleSearch",
      label: "Google",
      disabled: false,
      selected: false,
    },
    {
      id: "search",
      value: "googleSearchNew",
      label: "Google Search",
      disabled: false,
      selected: false,
    },
    {
      id: "meta",
      value: "MetaAds",
      label: "Facebook",
      disabled: false,
      selected: false,
    },
    {
      id: "insta",
      value: "instaAds",
      label: "Instagram",
      disabled: false,
      selected: false,
    },
    {
      id: "youtube",
      value: "youtubeAds",
      label: "YouTube",
      disabled: false,
      selected: false,
    },
    {
      id: "friend",
      value: "fromAFriendNew",
      label: "From a friend",
      disabled: false,
      selected: false,
    },
    {
      id: "friend",
      value: "fromAFriend",
      label: "Other",
      disabled: false,
      selected: false,
    },
  ];

  const [form, setForm] = useState({
    data: {
      firstName: "",
      lastName: "",
      email: "",
      phoneNo: "",
      company: "",
      password: "",
      confirmPassword: "",
      isTermsandcon: isTermsandcon,
    },
    errorMessage: {
      firstName: "",
      lastName: "",
      email: "",
      phoneNo: "",
      company: "",
      password: "",
      confirmPassword: "",
    },
  });

  const handleSelectSurvey = (value, label) => {
    setAnswer({ value, label });
    setDropDown(false);
  };

  const onSubmitHandler = async (answer) => {
    setDropDown(false);
    if (!answer) {
      alert("Please select an option.");
      return;
    }
    try {
      await dispatch(addSurvey(answer));
      localStorage.setItem("userFilledSurvey", JSON.stringify(true));
    } catch (error) {
      alert("Failed to submit the survey. Please try again.");
    }
  };

  const detectSize = () => {
    setSize({ winWidth: window.innerWidth, winHeight: window.innerHeight });
  };

  useEffect(() => {
    window.addEventListener("resize", detectSize);
    return () => {
      window.removeEventListener("resize", detectSize);
    };
  }, [size]);

  const onChangeHandler = (e) => {
    e.preventDefault();
    const { name, value } = e.target;
    setForm((prevForm) => {
      const newForm = { ...prevForm };
      if (name === "firstName" || name === "lastName") {
        newForm.errorMessage[name] =
          value.length < 2 ? "Name is too short" : "";
      } else if (name === "phoneNo") {
        newForm.errorMessage[name] =
          value.length < 10 || value.length > 12 ? "Enter 10 digit" : "";
      } else if (name === "password") {
        newForm.errorMessage[name] =
          value.length < 8 ? "Password must be at least 8 characters" : "";
      } else if (name === "confirmPassword") {
        newForm.errorMessage[name] =
          value !== form.data.password ? "Confirm Password must match" : "";
      } else if (name === "email") {
        newForm.errorMessage[name] = "";
      }
      const formValues = { ...form, data: { ...form.data, [name]: value } };
      return {
        ...newForm,
        data: formValues.data,
        errorMessage: newForm.errorMessage,
      };
    });
  };

  const submitHandler = async (e) => {
    e.preventDefault();
    if (answer.value === "") {
      setError("Please select an option. ");
    } else {
      setSignupLoading(true);
      const res = await dispatch(register(form?.data));
      const resError = res?.response?.data?.error;
      if (res?.status === 200) {
        if (res?.data?.success) {
          setSignupLoading(false);
          setIsSignUpSuccess(true);
        }
      } else if (resError && resError?.includes("User with email")) {
        form.errorMessage.email = "Email already exist";
        setSignupLoading(false);
        setForm({ ...form });
      } else {
        form.errorMessage.email = "";
        setSignupLoading(false);
        setForm({ ...form });
      }
    }
  };

  const handleSubmitOtp = async () => {
    if (otp) {
      const res = await dispatch(verifyOTP(otp, otpType));
      if (res?.data === "Successfully verified") {
        setIsSignUpSuccess(false);
        onSubmitHandler(answer.value);
        // navigate("dashboard");
        navigate("/dashboard/new-user");
        setOpt("");
        setInValidOtp("");
      } else if (res?.response?.data === "Invalid otp") {
        setInValidOtp(res?.response?.data);
      }
    }
  };

  const handleResendOtp = async () => {
    const res = await dispatch(resndOTP());
    if (res?.data?.message === "otp Resent successsful") {
      setInValidOtp(`OTP Resent Check Your Mail Agian`);
    }
  };

  const handleShowPassword = () => {
    setShowPassword(!showPassword);
  };
  return (
    <>
      {isSignUpSuccess && (
        <VerifyOTPModal
          isSignUpSuccess={isSignUpSuccess}
          setIsSignUpSuccess={setIsSignUpSuccess}
          otp={otp}
          setOpt={setOpt}
          handleSubmitOtp={handleSubmitOtp}
          handleResendOtp={handleResendOtp}
          inValidOtp={inValidOtp}
          setInValidOtp={setInValidOtp}
        />
      )}

      {signupLoading && (
        <div className="modal-overlayLoader">
          <img
            src={Scrollx_animate}
            className="absolute opacity-80 LoadOnProjectimg"
            width="120px"
            height="120px"
          />
          <p className="mt-[8rem] text-[0.9rem] text-white">Signing Up...</p>
          {/* <LoaderGlobal /> */}
        </div>
      )}

      <div className={"main_div"}>
        <div className="w-full h-full  LoginLeft-block  flex">
          {/* Left Block */}
          <div className="w-[55%] loginLeft-block flex flex-col justify-center items-center">
            <img className="w-[70%] mb-5" src={ScrollX_demo} alt="" />
            <div className=" text-white text-[30px] flex flex-col justify-center items-center text-center">
              <h1 className="Syne700 py-1">ScrollX is a game changer!</h1>
              <h1 className="Syne700 py-1">It saved us days of works to</h1>
              <h1 className="Syne700 py-1">submit our film to festivals.</h1>
              <h3 className="text-base mt-4 FontFamily-Avenir-reg">
                - Moon Unit Productions
              </h3>
            </div>
          </div>
          {/* Right Block */}
          <div className="w-[45%] loginRight-block flex justify-center items-center bg-white">
            <div className=" w-[60%] h-1/2 flex flex-col justify-center items-center loginRight-blockPhone">
              <div className="flex flex-col justify-center items-center ">
                <h1 className="text-black text-[30px] uppercase Syne700 pb-4">
                  Welcome
                </h1>
                <h2 className="text-black xl:text-2xl Syne700">
                  Sign Up for Easy End Credits
                </h2>
                <h3 className="FontFamily-Avenir-reg xl:text-lg text-[#585858] pt-[10px]">
                  Already a member?{" "}
                  <Link to="/">
                    <span className="text-[#5100ff] xl:text-lg FontFamily-Avenir-reg">
                      Sign In
                    </span>
                  </Link>
                </h3>
                {/* <button className="xl:w-[70%] my-3 mt-4 flex justify-center items-center border-[2px] border-[#797979] rounded-xl py-1 px-3 "><img className="w-6 mr-3" src={Google_Logo} alt="" /><h1 className="FontFamily-Avenir-reg xl:text-base text-black">Sign up with Google</h1></button> */}
                <SignUpWithGoogle />
              </div>

              <div className="w-full flex justify-center items-center pt-[14px]">
                <div className="xl:w-[21%] h-[1px] self-center bg-[#797979] mt-[4px]"></div>
                <div className="xl:w-[65%] 2xl:w-[55%]  text-center FontFamily-Avenir-reg xl:text-lg text-gray-800">
                  or sign up with your email
                </div>
                <div className="xl:w-[21%]  h-[1px] self-center bg-[#797979]"></div>
              </div>
              <div className="w-full">
                <form onSubmit={submitHandler}>
                  <div className="mb-6 mt-6 flex  w-full justify-center ">
                    <div className="w-[98%] ">
                      {/* <label htmlFor="firstName" className="label_signup_text">First Name</label> */}
                      <input
                        className="input_signup_block FontFamily-Avenir-reg dark:bg-gray-700 dark:border-gray-600  dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                        type="text"
                        id="firstName"
                        name="firstName"
                        value={form?.data?.firstName}
                        onChange={(e) => onChangeHandler(e)}
                        placeholder="Full Name"
                        required
                      />
                      {form?.errorMessage?.firstName && (
                        <span style={{ color: "#c64747", fontSize: "12px" }}>
                          {form?.errorMessage?.firstName}
                        </span>
                      )}
                    </div>
                    {/* <div className="w-[48%]">
                      <input className="input_signup_block dark:bg-gray-700 dark:border-gray-600  dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                        type="text"
                        id="lastName"
                        name="lastName"
                        value={form?.data?.lastName}
                        onChange={(e) => onChangeHandler(e)}
                        placeholder="Last Name"
                        required
                      />
                      {form?.errorMessage?.lastName && (
                        <span style={{ color: "#c64747", fontSize: "12px" }}>{form?.errorMessage?.lastName}</span>
                      )}
                    </div> */}
                  </div>
                  <div className=" flex justify-center mb-6">
                    <div className="w-[98%]  ">
                      {/* <label htmlFor="email" className="label_signup_text">Email address</label> */}
                      <input
                        className="input_signup_block FontFamily-Avenir-reg dark:bg-gray-700 dark:border-gray-600  dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                        type="email"
                        id="email"
                        name="email"
                        value={form?.data?.email}
                        onChange={(e) => onChangeHandler(e)}
                        placeholder="Email"
                        required
                      />
                      {form?.errorMessage?.email && (
                        <span style={{ color: "#c64747", fontSize: "12px" }}>
                          {form?.errorMessage?.email}
                        </span>
                      )}
                    </div>
                    {/* <div className="w-[48%] 2xl:mb-6 xl:mb-0 ">
                      <input className="input_signup_block dark:bg-gray-700 dark:border-gray-600  dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                        type="number"
                        id="phoneNo"
                        name="phoneNo"
                        value={form?.data?.phoneNo}
                        onChange={(e) => onChangeHandler(e)}
                        onInput={(e) => {
                          e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 10);
                        }}
                        placeholder="Contact Number"
                        required
                      />
                      {form?.errorMessage?.phoneNo && (
                        <span style={{ color: "#c64747", fontSize: "12px" }}>{form?.errorMessage?.phoneNo}</span>
                      )}
                    </div> */}
                  </div>
                  <div className="mb-6 flex justify-center">
                    <div className="w-[98%]">
                      <div className="flex items-center">
                        <input
                          className="input_signup_block FontFamily-Avenir-reg dark:bg-gray-700 dark:border-gray-600  dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                          type={showPassword ? "text" : "password"}
                          id="password"
                          name="password"
                          value={form?.data?.password}
                          onChange={(e) => onChangeHandler(e)}
                          autoComplete="on"
                          placeholder="Password"
                          required
                        />
                        <div
                          onClick={handleShowPassword}
                          className="absolute ml-[62%] sm:ml-[20%] md:ml-[24.5%] text-black w-5 h-5 cursor-pointer"
                        >
                          {showPassword ? <FaEye /> : <FaEyeSlash />}
                        </div>
                      </div>
                      {form?.errorMessage.password && (
                        <span style={{ color: "#c64747", fontSize: "12px" }}>
                          {form?.errorMessage?.password}
                        </span>
                      )}
                    </div>
                    {/* <div className="w-[48%]">
                      <input className="input_signup_block dark:bg-gray-700 dark:border-gray-600  dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                        type="password"
                        id="confirmPassword"
                        name="confirmPassword"
                        value={form?.data?.confirmPassword}
                        onChange={(e) => onChangeHandler(e)}
                        autoComplete="on"
                        placeholder="Confirm Password"
                        required
                      />
                      {form?.errorMessage?.confirmPassword && (
                        <span style={{ color: "#c64747", fontSize: "12px" }}>{form?.errorMessage?.confirmPassword}</span>
                      )}
                    </div> */}
                  </div>

                  <div className="mb-6 flex justify-center cursor-pointer">
                    <div className="w-[98%]">
                      <div className="flex items-center">
                        {/* <input
                          className="input_signup_block FontFamily-Avenir-reg dark:bg-gray-700 dark:border-gray-600  dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                          type={showPassword ? "text" : "password"}
                          id="password"
                          name="password"
                          value={form?.data?.password}
                          onChange={(e) => onChangeHandler(e)}
                          autoComplete="on"
                          placeholder="Password"
                          required
                        /> */}
                        <div className="w-full">
                          <div
                            className="surveySelect flex justify-between items-center FontFamily-Avenir-reg dark:bg-gray-700 dark:border-gray-600 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                            onClick={() => setDropDown(!dropDown)}
                          >
                            <span>
                              {answer.label === ""
                                ? "Where did you discover ScrollX?"
                                : answer.label}
                            </span>{" "}
                            {dropDown ? <FaAngleUp /> : <FaAngleDown />}
                          </div>
                          {dropDown && (
                            <div className="absolute border-2 h-[11rem] overflow-auto w-[26.6%] bg-white border-gray-300 mt-2 rounded">
                              {data.map((item) => (
                                <div
                                  className="hover:bg-gray-200 cursor-pointer py-1 px-2 border-b-2"
                                  key={item.id}
                                  value={item.value}
                                  onClick={() =>
                                    handleSelectSurvey(item.value, item.label)
                                  }
                                >
                                  {item.label}
                                </div>
                              ))}
                            </div>
                          )}
                          {error && (
                            <span
                              style={{ color: "#c64747", fontSize: "12px" }}
                            >
                              {error}
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* <div className="mb-6 inputbottom">
                    <input className="input_signup_block dark:bg-gray-700 dark:border-gray-600  dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      id="company"
                      type="text"
                      name="company"
                      value={form?.data?.company}
                      onChange={(e) => onChangeHandler(e)}
                      placeholder="Company Name"
                      required
                    />
                  </div> */}

                  <div className="flex flex-col justify-between items-center">
                    <div className="signupbtn w-[163px] SignUP-btn text-center px-2 py-[8px] yellow-gradient FontFamily-Avenir-reg tracking-widest rounded-2xl uppercase xl:text-base">
                      <button
                        className="FontFamily-Avenir-reg tracking-widest rounded-2xl uppercase cursor-pointer"
                        type="submit"
                        disabled={
                          !form?.data.firstName ||
                          !form?.data?.email ||
                          !form?.data?.password
                        }
                      >
                        Sign Up
                      </button>
                    </div>
                    <div className="flex justify-center items-center">
                      <div className=" ">
                        {/* <Checkbox isTermsandcon={isTermsandcon} setIsTermsandcon={setIsTermsandcon} /> */}
                        <div className="flex justify-center items-center w-[300px] mt-3">
                          {/* Accept{" "} */}
                          <span className=" text-center Terms_conditions  flex-col text-xs  FontFamily-Avenir-reg  text-gray-800">
                            By signing up, you agree to our
                            <div className="">
                              <a
                                className=" xl:text-xs  FontFamily-Avenir-reg  text-gray-800 mr-[3px]"
                                href="https://www.scrollx.io/terms-of-service"
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                Terms of Service
                              </a>
                              <span className="xl:text-xs  FontFamily-Avenir-reg text-gray-800">
                                and
                              </span>
                              <a
                                className=" xl:text-xs  FontFamily-Avenir-reg ml-[3px] text-gray-800"
                                href="https://www.scrollx.io/privacy-policy"
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                Privacy Policy.
                              </a>
                            </div>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* After Signup, Mobile View Response */}
      {/* <div id="warning-messageas" style={{ width: '100%', height: '100%' }}>
          <div className='w-full h-full  LoginLeft-block md:flex md:flex-row flex flex-col-reverse justify-center items-center '>
            <div className='md:w-[55%] h-1/2  flex justify-center items-center'>
              <div className=' text-white text-4xl flex flex-col justify-center items-center text-center'>
                <img className='w-80' src={laptopScreenV3} alt="" />
              </div>
            </div>
            <div className=' md:w-[45%] w-full md:h-full h-1/2   flex justify-center items-center bg-white'>
              <div className=' md:w-[85%] w-[90%]  h-1/2 flex flex-col justify-center items-center '>
                <div className='flex flex-col justify-center items-center '>
                  <h1 className='text-black md:text-[26px] text-xl  Syne700  pb-4 text-center'>Thanks for Signing Up!</h1>
                  <h3 className='FontFamily-Avenir-reg text-sm text-[#585858] py-[10px] text-center'>For the best experience, grab your laptop or desktop because our app is not available on phones.</h3>
                  <h3 className='FontFamily-Avenir-reg text-sm text-[#585858] pt-[10px] text-center'>Lights, camera, action awaits on the big screen! 🎥✨</h3>
                </div>
              </div>
            </div>
          </div>
      </div> */}
    </>
  );
}
